module.exports = __webpack_public_path__ + "static/media/red.0bbe5dd3.svg";